import { storeGet } from '@/store/store-utils';

const state = {
    accessApprovals: [], // filterOptionsData
    accessApprovalsCache: {},
    approvalsList: [],   // data
    approvalsListMeta: {},
    approvalsListCache: {},
    loading: false,
};

const getters = {
    getAccessApprovals: (state) => state.accessApprovals,
    getApprovalsList: (state) => state.approvalsList,
    getApprovalsListMeta: (state) => state.approvalsListMeta,
    isLoading: (state) => state.loading,
};

const mutations = {
    SET_LOADING(state, loading) {
        state.loading = loading;
    },
    SET_ACCESS_APPROVALS(state, data) {
        state.accessApprovals = data;
    },
    SET_ACCESS_APPROVALS_CACHE(state, { key, data }) {
        state.accessApprovalsCache[key] = data;
    },
    SET_APPROVALS_LIST(state, { data, meta }) {
        state.approvalsList = data;
        state.approvalsListMeta = meta;
    },
    SET_APPROVALS_LIST_CACHE(state, { key, data, meta }) {
        state.approvalsListCache[key] = { data, meta };
    },
    CLEAR_APPROVALS_CACHE(state) {
        state.approvalsListCache = {};
        state.accessApprovalsCache = {};
    }
};

const actions = {
    async fetchAccessApprovals({ commit, state, rootState }, { filter, axiosInstance, forceRefresh = false }) {
        const cacheKey = JSON.stringify(filter);
        if (!forceRefresh && state.accessApprovalsCache[cacheKey]) {
            console.log('[Store] Using cached Access Approvals');
            commit('SET_ACCESS_APPROVALS', state.accessApprovalsCache[cacheKey]);
            return { data: state.accessApprovalsCache[cacheKey], status: 'success' };
        }

        commit('SET_LOADING', true);
        try {
            const response = await storeGet(axiosInstance, rootState, "/v2/varianceanalysis/approvals/getAccessApprovals", filter);
            if (response.data.status === "success") {
                const data = (response.data || {}).data || [];
                commit('SET_ACCESS_APPROVALS', data);
                commit('SET_ACCESS_APPROVALS_CACHE', { key: cacheKey, data });
                return { data, status: 'success' };
            } else {
                throw new Error("Error reading access approvals data");
            }
        } catch (error) {
            commit('sbError', error.message || "Unknown error", { root: true });
            console.error(error);
            throw error;
        } finally {
            commit('SET_LOADING', false);
        }
    },

    async fetchApprovalsListWithCounts({ commit, state, rootState }, { filter, axiosInstance, forceRefresh = false }) {
        const cacheKey = JSON.stringify(filter);
        if (!forceRefresh && state.approvalsListCache[cacheKey]) {
            console.log('[Store] Using cached Approvals List with Counts');
            const { data, meta } = state.approvalsListCache[cacheKey];
            commit('SET_APPROVALS_LIST', { data, meta });
            return { data, meta, status: 'success' };
        }

        commit('SET_LOADING', true);
        try {
            const response = await storeGet(axiosInstance, rootState, "/v2/varianceanalysis/approvals/getListWithCounts", filter);
            if (response.data.status === "success") {
                const data = (response.data || {}).data || [];
                const meta = (response.data || {}).meta || {};
                commit('SET_APPROVALS_LIST', { data, meta });
                commit('SET_APPROVALS_LIST_CACHE', { key: cacheKey, data, meta });
                return { data, meta, status: 'success' };
            } else {
                throw new Error("Error reading approvals list");
            }
        } catch (error) {
            commit('sbError', error.message || "Unknown error", { root: true });
            console.error(error);
            throw error;
        } finally {
            commit('SET_LOADING', false);
        }
    },

    async approveRequest({ commit }, { id, type, axiosInstance }) {
        // commit('SET_LOADING', true); 
        try {
            let url = "/v2/varianceanalysis/approvals/approve/" + id;
            if (type === 'glselectionchange') {
                url = "/v2/varianceanalysis/approvals/approveforglselection/" + id;
            }
            const response = await axiosInstance.post(url);
            if (response.data.status === "success") {
                commit('sbSuccess', "Change request approved and the changes will be impacted only if there is/are no conflicts", { root: true });
                commit('CLEAR_APPROVALS_CACHE'); // Invalidate cache on update
                return { success: true, data: response.data.data };
            } else {
                throw new Error(response.data.message || "Error approving request");
            }
        } catch (error) {
            commit('sbError', error.message || "Unknown error!", { root: true });
            console.error(error);
            return { success: false, error };
        } finally {
            // commit('SET_LOADING', false);
        }
    },

    async rejectRequest({ commit }, { id, type, axiosInstance }) {
         try {
            let url = "/v2/varianceanalysis/approvals/reject/" + id;
            if (type === 'glselectionchange') {
                url = "/v2/varianceanalysis/approvals/rejectforglselection/" + id;
            }
            const response = await axiosInstance.post(url);
            if (response.data.status === "success") {
                commit('sbSuccess', "Change request rejected", { root: true });
                commit('CLEAR_APPROVALS_CACHE'); // Invalidate cache on update
                return { success: true, data: response.data.data };
            } else {
                throw new Error("Error rejecting request");
            }
        } catch (error) {
            commit('sbError', error.message || "Unknown error!", { root: true });
            console.error(error);
            return { success: false, error };
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
